export const labels = {
	title: {
		label: "Label.MobileCreator.InfoDialog.Title",
		default: "Info",
	},
	close: {
		label: "Label.MobileCreator.InfoDialog.Close",
		default: "Close",
	},
};
